import { useState, useEffect, CSSProperties } from 'react';
import { useWindowSize } from './useWindowSize';
import { calculateHoneycombPositions } from '../utility/Navigation/honeycombCalculator';

export const useHoneycombLayout = (itemCount: number): CSSProperties[] => {
  const [itemPositions, setItemPositions] = useState<CSSProperties[]>([]);
  const { width: windowWidth, height: windowHeight } = useWindowSize();
  
  useEffect(() => {
    if (itemCount === 0) return;
    
    // Calculate positions based on the number of items
    const positions = calculateHoneycombPositions(itemCount, windowWidth, windowHeight);
    setItemPositions(positions);
  }, [itemCount, windowWidth, windowHeight]); // Recalculate when window dimensions change

  return itemPositions;
};